import JQuery from 'jquery';
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import {sync} from 'vuex-router-sync';
import VueTagManager from 'vue-tag-manager';
import App from './App.vue';
import router from './router';
import store from './store';
import {EventBusPlugin} from './events/bus';
import FiltersPlugin from './filters';
import validationIniter from './commons/validation';
import {i18n} from './i18n/index';

window.jQuery = JQuery;
window.JQuery = JQuery;
window.$ = JQuery;

Vue.config.productionTip = false;

Vue.use(EventBusPlugin);
Vue.use(FiltersPlugin);

const gtmId = store.state.options.gtm.id;
if (gtmId) {
    Vue.use(VueTagManager, {
        gtmId,
        dataLayer: {
            channel: 'store',
            firstLevelCategory: '',
            secondLevelCategory: '',
            shopCategory: 'checkout',
            storeCountry: 'IT',
            thirdLevelCategory: '',
        },
    });
}

Vue.use(VeeValidate, validationIniter(i18n));

sync(store, router);

new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount('#app');
